import * as React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import ValueParameter from "views/logic/parameters/ValueParameter";
import LookupTableParameter from "views/logic/parameters/LookupTableParameter";
import OptionParameter from "enterprise/parameters/components/option/OptionParameter";
import WatchlistParameter from "watchlist/WatchlistParameter";
import { useParameterTypes } from "./ParameterTypes";
const builderForType = (newType) => {
  switch (newType) {
    case OptionParameter.type:
      return OptionParameter.builder();
    case ValueParameter.type:
      return ValueParameter.builder();
    case LookupTableParameter.type:
      return LookupTableParameter.builder();
    case WatchlistParameter.type:
      return WatchlistParameter.builder();
    default:
      throw new Error(`Invalid parameter type: ${newType}`);
  }
};
const migrateParameterToNewType = (newType) => (parameter) => {
  const { title, description, name } = parameter;
  const newBuilder = builderForType(newType);
  return newBuilder.name(name).title(title).description(description).build();
};
const ParameterDataTypesSelect = ({ idx, validationState, value, onChange }) => {
  var _a, _b;
  const { t } = useTranslation("enterprise_common");
  const parameterTypes = useParameterTypes();
  const _onChange = useCallback(
    (event) => {
      const newType = event.target.value;
      onChange(migrateParameterToNewType(newType));
    },
    [onChange]
  );
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: `dataType-${idx}`,
      type: "select",
      name: "type",
      label: t("parameters.type"),
      value,
      bsStyle: (_a = validationState == null ? void 0 : validationState.type) == null ? void 0 : _a[0],
      help: (_b = validationState == null ? void 0 : validationState.type) == null ? void 0 : _b[1],
      onChange: _onChange
    },
    parameterTypes.map(({ type, title }) => /* @__PURE__ */ React.createElement("option", { key: type, value: type }, title))
  );
};
export default ParameterDataTypesSelect;
